module.exports = __webpack_public_path__ + "img/webdevelopment.8784cb96.jpg";